module.exports = "//public.zight.com/packs/media/images/markers/m_5-a4fa4bc9811b4b56d434ab885c282fe0.svg";